import { Link } from "react-router-dom";
import { useApp } from "../../common/contexts/AppContext";
import BaseContainerWrapper from "../../common/components/BaseContainerWrapper";
import useIncidents from "../../common/hooks/pages/useIncidents";
import { useQuery, useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import ListIncidents from "../components/ListIncidents";
import ApiValidate from "../../common/components/ApiValidate";
import { useState } from "react";
import CompletedIncidents from "../components/CompletedIncidents";

function ListIncidentsContainer() {
  const { isOwner } = useApp();
  const [openTab, setOpenTab] = useState(1);

  const { getIncidents, getIncidentStatusTypes } = useIncidents();

  const { toast } = usePopup();

  const { data, isError, isLoading } = useQuery({
    retry: false,
    queryKey: "getIncidents",
    queryFn: getIncidents,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting incidents!";

      toast(message, "error");
    },
  });

  const { data: statusTypesData } = useQuery({
    retry: false,
    queryKey: "getIncidentStatusTypes",
    queryFn: getIncidentStatusTypes,
    onSuccess: (res) => {},
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting incidents status types!";

      toast(message, "error");
    },
  });

  const { incidents } = data?.data || {};

  const { incidentStatusTypes } = statusTypesData?.data || {};

  return (
    <BaseContainerWrapper>
      <div className="flex justify-between items-center pb-8 border-b">
        <div className="text-2xl font-bold">Incidents</div>
        {isOwner ? (
          <Link
            to="/add_incident"
            className="rounded-md common_bg text-white px-4 py-2 nav_link-500 transition ease-in-out duration-300"
          >
            Add Incident
          </Link>
        ) : null}
      </div>

      <div className="flex flex-wrap">
        <div className="w-full">
          <ul
            className="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row"
            role="tablist"
          >
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 1
                    ? "text-green bg-" + "-600"
                    : "text-" + "-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
              >
                <i className="fas fa-space-shuttle text-base mr-1"></i>
                Open
              </a>
            </li>
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal " +
                  (openTab === 2
                    ? "text-green bg-" + "-600"
                    : "text-" + "-600 bg-white")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                <i className="fas fa-docs text-base mr-1"></i> Incidents
              </a>
            </li>
          </ul>
          <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
            <div className="px-4 py-5 flex-auto">
              <div className="tab-content tab-space">
                <div className={openTab === 1 ? "block" : "hidden"} id="link1">
                  {isError ? (
                    <div className="mt-6 text-red-500">
                      Something went wrong while getting incidents!
                    </div>
                  ) : incidents?.length ? (
                    <ListIncidents
                      incidents={incidents}
                      incidentStatusTypes={incidentStatusTypes}
                    />
                  ) : (
                    <div className="mt-6 text-gray-500">
                      Incidents not found
                    </div>
                  )}
                </div>
                <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                  {isError ? (
                    <div className="mt-6 text-red-500">
                      Something went wrong while getting incidents!
                    </div>
                  ) : incidents?.length ? (
                    <CompletedIncidents
                      incidents={incidents}
                      incidentStatusTypes={incidentStatusTypes}
                    />
                  ) : (
                    <div className="mt-6 text-gray-500">
                      Incidents not found
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseContainerWrapper>
  );
}

export default ListIncidentsContainer;
